export function isOnline(state) {
  return state.isOnline
}

export function instanceId(state) {
  return state.instanceId
}
